<template>
  <div id="themeSelection">
    <v-container class="pa-0">
        <v-layout>
        <v-flex class="xs12 sm12 mb-5">
           <v-btn fab absolute left to="dashboard" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
        </v-layout>
    </v-container>
      <v-container grid-list-md fluid>
        <app-stepper :itemList="stepperList"></app-stepper>
        <v-layout wrap row>
          <v-flex v-for="item in Template" class="pa-1" :key="item.id" xs12 sm6 md4 lg3>
            <div class="itemWrapper" :class="{ selected: Account.template && Account.template.template && Account.template.template.id === item.id }" v-if="item.default_page">
              <v-card hover>
                <a @click="viewTemplate(item)">
                  <img 
                    :src="`${config.uploadPath}` + item.default_page.webPath"
                    :alt="item.name"
                    width="100%"
                  />
                </a>
                <v-card-actions>
                  <h5 class="templateName">{{item.name.toUpperCase()}}</h5>
                </v-card-actions>
              </v-card>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
  </div>
</template>
<script>
/* global session store config */
import { getCollection } from '../../helpers/helpers';
import appStepper from '../../components/appStepper';
export default {
  components: {
    appStepper
  },
  data: () => ({
    config: config,
    entity: 'Template',
    stepperList: [
      {
        name: 'REVIEW',
        description: 'Look through themes.',
        image: '/static/stepper/review.jpg'
      },
      {
        name: 'SELECT THEME',
        description: 'Select the right theme for you.',
        image: '/static/stepper/theme.jpg'
      },
      {
        name: 'SELECT COLOR',
        description: 'Select the right color for you.',
        image: '/static/stepper/color.jpg'
      },
      {
        name: "YOU'RE DONE",
        description: 'You are all done. We will take your selected theme and start putting it together for you !',
        image: '/static/stepper/done.jpg'
      }
    ]
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Template: {
      set (value) {
        store.commit('setTemplate', value);
      },
      get () {
        return store.state.Template;
      }
    },
    Account: {
      set (value) {
        store.commit('setAccount', value);
      },
      get () {
        return store.state.Account;
      }
    },
    TemplateArray: {
      set (value) {
        store.commit('setTemplateArray', value);
      },
      get () {
        return store.state.TemplateArray;
      }
    }
  },
  created () {
    this.initialize();
  },
  methods: {
    async initialize () {
      if (!this[this.entity].length) {
        let { error, data } = await getCollection(this.entity, true);
        if (error) {
          console.log(error);
        } else {
          this[this.entity] = data;
        }
      }
    },
    viewTemplate (item) {
      if (!this.TemplateArray[item.id]) {
        this.TemplateArray[item.id] = item;
      }
      this.$router.push({ 'path': '/templates/' + item.id });
    }
  }
};
</script>
<style scoped>

  .itemWrapper.selected {
    border: 3px solid #4c9e8c;
  }
  .itemWrapper {
    padding: 24px;
    background: #f1f9f7;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Template/listFamily.vue